/**
 * sentry.ts
 *
 * Lane 0 (docs/designs/observability-and-usage-metering.md): client-side
 * Sentry, the third of three Lane 0 surfaces (control plane, client,
 * daemon-proxy). Imported as the very FIRST line of src/index.tsx — before
 * `./App` — so it initializes before anything else in the app, matching
 * Sentry's own guidance for catching the earliest possible errors.
 *
 * Same architecture decision as the server side (server/instrument.js):
 * Sentry.init() runs unconditionally, no custom on/off flag. An unset
 * REACT_APP_SENTRY_DSN is the SDK's own safe no-op, not something built
 * here — so this is "always active" (nothing to remember to flip) and
 * "no breaking changes" (safe with zero config) at the same time. CRA only
 * inlines env vars prefixed REACT_APP_ at build time, so that prefix is
 * required (see client/.env.example).
 *
 * tracesSampleRate: 0 — error tracking only, matching the server-side
 * decision. No browserTracingIntegration, no router instrumentation; that's
 * a separate, deliberate cost/volume call this PR doesn't make.
 */

import * as _Sentry from '@sentry/react';
import { scrubEvent } from './sentryScrub';

_Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV || 'development',
  release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
  beforeSend: (event) => scrubEvent(event),
  tracesSampleRate: 0,
});

export const Sentry = _Sentry;
